import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPlanReviewSubmissionTypesAdminQueryVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
}>;


export type GetPlanReviewSubmissionTypesAdminQuery = { __typename?: 'query_root', plan_review_submission_types: Array<{ __typename?: 'plan_review_submission_types', id: any, jurisdiction_id: any, code: string, name: string, short_name?: string | null, sort_order: number, active: boolean, plan_review_requirement_submission_types_aggregate: { __typename?: 'plan_review_requirement_submission_types_aggregate', aggregate?: { __typename?: 'plan_review_requirement_submission_types_aggregate_fields', count: number } | null } }> };


export const GetPlanReviewSubmissionTypesAdminDocument = gql`
    query getPlanReviewSubmissionTypesAdmin($jurisdictionId: uuid!) {
  plan_review_submission_types(
    where: {jurisdiction_id: {_eq: $jurisdictionId}}
    order_by: [{sort_order: asc}, {name: asc}]
  ) {
    id
    jurisdiction_id
    code
    name
    short_name
    sort_order
    active
    plan_review_requirement_submission_types_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetPlanReviewSubmissionTypesAdminQuery__
 *
 * To run a query within a React component, call `useGetPlanReviewSubmissionTypesAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanReviewSubmissionTypesAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanReviewSubmissionTypesAdminQuery({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *   },
 * });
 */
export function useGetPlanReviewSubmissionTypesAdminQuery(baseOptions: Apollo.QueryHookOptions<GetPlanReviewSubmissionTypesAdminQuery, GetPlanReviewSubmissionTypesAdminQueryVariables> & ({ variables: GetPlanReviewSubmissionTypesAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanReviewSubmissionTypesAdminQuery, GetPlanReviewSubmissionTypesAdminQueryVariables>(GetPlanReviewSubmissionTypesAdminDocument, options);
      }
export function useGetPlanReviewSubmissionTypesAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanReviewSubmissionTypesAdminQuery, GetPlanReviewSubmissionTypesAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanReviewSubmissionTypesAdminQuery, GetPlanReviewSubmissionTypesAdminQueryVariables>(GetPlanReviewSubmissionTypesAdminDocument, options);
        }
export function useGetPlanReviewSubmissionTypesAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanReviewSubmissionTypesAdminQuery, GetPlanReviewSubmissionTypesAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanReviewSubmissionTypesAdminQuery, GetPlanReviewSubmissionTypesAdminQueryVariables>(GetPlanReviewSubmissionTypesAdminDocument, options);
        }
export type GetPlanReviewSubmissionTypesAdminQueryHookResult = ReturnType<typeof useGetPlanReviewSubmissionTypesAdminQuery>;
export type GetPlanReviewSubmissionTypesAdminLazyQueryHookResult = ReturnType<typeof useGetPlanReviewSubmissionTypesAdminLazyQuery>;
export type GetPlanReviewSubmissionTypesAdminSuspenseQueryHookResult = ReturnType<typeof useGetPlanReviewSubmissionTypesAdminSuspenseQuery>;
export type GetPlanReviewSubmissionTypesAdminQueryResult = Apollo.QueryResult<GetPlanReviewSubmissionTypesAdminQuery, GetPlanReviewSubmissionTypesAdminQueryVariables>;